export default __webpack_public_path__ + "static/media/primary-logo-icon.67e9bfbd.svg";